import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as micropython from './micropython';
import * as tios from './tios';
import * as simulator from './simulator';
export default class DateTimeNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Get Current DateTime';
        this.id = 'node_datetime';
        this.icon = 'BsClock';
        this.requirements = [['tios', 'micropython']];
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Get Current Time',
                portId: 'timestamp_get',
                params: [],
            },
        ];

        this.outputs = [
            {
                name: 'Current Time',
                portId: 'timestamp_now',
                params: [
                    {
                        name: 'time_now',
                        dataType: TibboDataType.DATETIME,
                    },
                ],
            },
        ];

        // const settings: Setting[] = [
        //     {
        //         id: 'FORMAT',
        //         name: 'Format',
        //         settingType: SettingType.OPTION,
        //         required: true,
        //         default: 'datetime',
        //         options: [
        //             {
        //                 name: 'Date and Time',
        //                 value: 'datetime',
        //             },
        //             {
        //                 name: 'Time of Day',
        //                 value: 'time',
        //             },
        //         ],
        //     },
        // ];

        // this.settings = this.settings.concat(settings);
    }

    getDependencies() {
        return ['datetime', 'sntp'];
    }

    getSettingValue(settingId: string): string {
        const project: ProjectConfiguration = this.project;
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            // const FORMAT = this.getSettingValue('FORMAT');
            return 'Get Current DateTime';
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        return 'Get Current DateTime';
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `
##### Get Current Date/Time
This block gets the current date and time, which are output as a string using the selected formatting.`;
    }
}
